/* eslint-disable no-console */
import * as Sentry from '@sentry/react';

let globalLogger: typeof console = console;

function bindMethod(logger: typeof globalLogger, key: 'log' | 'info' | 'warn' | 'error') {
  const originalFn = logger[key];

  const newFn = function (...args: any[]) {
    const obj = typeof args[0] === 'object' ? (args[0] as object) : undefined;
    const msg = typeof args[0] === 'string' ? args[0] : (args[1] as string | undefined);

    // dont error because of sentry
    try {
      /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
      const sentryLogger = (Sentry as any)?.logger;
      if (sentryLogger?.[key] != null) {
        sentryLogger[key](msg, obj);
      } else if (sentryLogger?.info != null) {
        sentryLogger.info(msg, obj);
      }
      /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
    } catch (_err) {
      // do nothing here
    }

    if (obj == null) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return originalFn.bind(logger)(msg, ...args);
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return originalFn.bind(logger)(obj, msg, ...args);
  };

  return newFn;
}

/**
 * Creates a namespaced logger. The logging level will be based on the
 * configured environment. If available a contextId will also be included
 *
 * @example
 * ```typescript
 * const logger = createLogger('notification-module');
 *
 * logger.info({ notificationId }, 'Created notification')
 * logger.error({ error, notificationId }, 'Failed to create notification')
 * ```
 */
export function create(env: string, setGlobal: boolean) {
  if (env === 'staging' || env === 'production') {
    console.log = bindMethod(console, 'log');
    console.info = bindMethod(console, 'info');
    console.warn = bindMethod(console, 'warn');
    console.error = bindMethod(console, 'error');
  }

  if (setGlobal) {
    globalLogger = console;
  }

  return console;
}

export const get = () => globalLogger;
export const getLogger = get;
